import { render, staticRenderFns } from "./ModalFeedback.vue?vue&type=template&id=408fbb5e&scoped=true"
import script from "./ModalFeedback.vue?vue&type=script&lang=js"
export * from "./ModalFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408fbb5e",
  null
  
)

export default component.exports